import {
  isNumber,
  isString
} from 'util'

//判断手机号是否合法，待完善
export function isOkMobileCountry(mobCountry) {
  if (isNumber(mobCountry)) {
    mobCountry += ''
  }
  //TODO: 待待定国家代码最多三位？
  if (!/^[+-]?\d{1,3}$/.test(mobCountry)) {
    return false
  }
  return true
}

//判断手机号是否合法，待完善
export function isOkMobile(mobile, mobCountry) {
  mobile += ''
  mobile = mobile.replace(/\s/g, '')
  if (isString(mobile) && /^\d{5,11}$/.test(mobile)) {
    mobCountry = mobCountry ? '' + mobCountry : '+86'
    if (/^\+?86$/.test(mobCountry)) { //大陆手机号
      return /^1\d{10}$/.test(mobile)
    }
    return true
  }
  return false
}


export function isOkMobCode(mobCode) {
    if (isNumber(mobCode)) {
        mobCode += ''
    }
    if (isString(mobCode) && /^\d{4,6}$/.test(mobCode)) {
        return true
    }
    return false
}


const countNick=(function(){
    var trim = function(strings){
        return ( strings || '' ).replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g,'')//+表示匹配一次或多次，|表示或者，\s和\u00A0匹配空白字符，/^以……开头，$以……结尾，/g全局匹配,/i忽略大小写
    }
    return function(_str){
        _str = trim(_str)   //去除字符串的左右两边空格
        var strLength = _str.length
        if( !strLength ){   //如果字符串长度为零，返回零
            return 0
        }
        var chinese=_str.match(/[\u4e00-\u9fa5]/g) //匹配中文，match返回包含中文的数组
        return strLength + ( chinese?chinese.length:0) //计算字符个数
    }
})()

export function isOkNick(nick) {
    var len = countNick(nick)
    if (len >= 4 && len <= 32) {//TODO:长度待精确检测
        if(/^[a-z\u4e00-\u9fa5][\w\u4e00-\u9fa5]+$/.test(nick)) {
            return true
        }
    }
    return false
}

// 至少6位
export function isOkPassword(pwd) {
    return !!pwd && pwd.length >= 6
}
